import { Injectable } from '@angular/core';
import { Http, RequestOptions, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { AppSettings } from '../providers/app-settings';

@Injectable()
export class GymService {

  private gymApiUrl: string;

  constructor(public http: Http, private appSettings: AppSettings) {
    this.gymApiUrl = this.appSettings.DB_API_ENDPOINT + 'gyms/';
  }

  private getDataInJson(res: Response) {
    return res.json();
  }

  public getAllGyms(): Promise<Array<any>> {
    return this.http.get(this.gymApiUrl, this.appSettings.apiOptions)
      .toPromise()
      .then(this.getDataInJson);
  }

  public addGym(gym): Observable<any> {
    return this.http.post(this.gymApiUrl, gym, this.appSettings.apiOptions)
      .map(this.getDataInJson);
  }

  public delGym(id): Observable<any> {
    return this.http.delete(this.gymApiUrl + id, this.appSettings.apiOptions);
  }

  public editGYm(gym): Observable<any> {
    return this.http.put(this.gymApiUrl + gym._id, gym, this.appSettings.apiOptions);
  }

  public getAllGymsOwnedBy(userId: string): Promise<Array<any>> {
    return this.http.get(this.gymApiUrl + 'owned_by/' + userId, this.appSettings.apiOptions)
      .toPromise()
      .then(this.getDataInJson);
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/services/gym.service.ts